import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import {
  ElderQuantityPipe,
  ElderTableComponent,
  ElderToastService,
  IDataContext,
} from '@elderbyte/ngx-starter'
import { TerminalWorkBatch } from '../terminal-work-batch'
import { MatIcon } from '@angular/material/icon'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkBatchLineComponent } from '../../../../orders/batches/work-batch-line/work-batch-line.component'
import { NewWorkBatch, WorkBatch, WorkBatchState } from '../../../../orders/batches/work-batch'
import { ValidationState } from '../../../../orders/work-items/work-item'
import { WorkBatchStateUtil } from '../../work-batch-state-util'
import { TerminalBatchService } from '../../batches/terminal-batch.service'
import { ActivatedRoute, Router } from '@angular/router'
import { MatSort } from '@angular/material/sort'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'

@Component({
  selector: 'app-terminal-work-batches-table',
  imports: [
    ElderTableComponent,
    MatIcon,
    ElderTranslatePipe,
    ElderQuantityPipe,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    WorkBatchLineComponent,
  ],
  templateUrl: 'terminal-work-batches-table.component.html',
  styles: ``,
})
export class TerminalWorkBatchesTableComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  data = input.required<IDataContext<TerminalWorkBatch>>()
  workStationId = input.required<string>()
  workCenterId = input.required<string>()
  private toastService = inject(ElderToastService)
  private terminalBatchService = inject(TerminalBatchService)
  private route = inject(ActivatedRoute)
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public batchClick(terminalBatch: TerminalWorkBatch): void {
    const batch = terminalBatch.workBatch
    if (this.canStartBatch(batch)) {
      if (batch.state === WorkBatchState.PREVIEW) {
        this.createBatch(
          new NewWorkBatch(
            batch.workOrderId,
            batch.productionLine.productionLinePath,
            this.workStationId()
          )
        )
      } else {
        this.openDetail(batch)
      }
    } else {
      if (batch.validationState !== ValidationState.VALIDATED) {
        this.toastService.info(batch.invalidityReason)
      } else {
        if (batch.mismatchReason) {
          this.toastService.info('terminals.configurations.no-match') // todo: add mismatch details
        } else {
          this.toastService.info('validation.messages.prev-wc-not-started')
        }
      }
    }
  }

  public canStartBatch(batch: WorkBatch): boolean {
    const segments = batch.productionLine.segments
    const currentSegment = WorkBatchStateUtil.getSegmentByWCId(segments, this.workCenterId())
    return (
      WorkBatchStateUtil.previousSegmentStarted(segments, currentSegment) &&
      batch.validationState === ValidationState.VALIDATED &&
      !batch.mismatchReason
    )
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private openDetail(batch: WorkBatch): void {
    this.router.navigate(['batches', batch.id], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
    })
  }

  private createBatch(newBatch: NewWorkBatch): void {
    this.terminalBatchService.createNew(newBatch).subscribe({
      next: (batch) => this.openDetail(batch.workBatch),
      error: (err) => this.toastService.error('Could not create new WorkBatch!', err),
    })
  }
}
